"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTeamInfo = exports.isSandboxInfo = exports.isInstanceGroupInfo = exports.isInstanceGroupType = exports.isTeamRole = exports.TeamRole = void 0;
const uuid_1 = require("../types/uuid");
const datelike_1 = require("../types/datelike");
const users_1 = require("./users");
const validation_1 = require("../validator/validation");
var TeamRole;
(function (TeamRole) {
    TeamRole["Member"] = "MEMBER";
    TeamRole["Owner"] = "OWNER";
    TeamRole["Guest"] = "GUEST";
})(TeamRole = exports.TeamRole || (exports.TeamRole = {}));
exports.isTeamRole = (0, validation_1.isLiteral)(TeamRole.Member, TeamRole.Guest, TeamRole.Owner);
exports.isInstanceGroupType = (0, validation_1.isLiteral)('SANDBOX', 'TEAM');
exports.isInstanceGroupInfo = (0, validation_1.isObjectOf)({
    id: uuid_1.isUUID,
    createdAt: datelike_1.isDateLike,
    owner: users_1.isUser,
});
exports.isSandboxInfo = (0, validation_1.isAllOf)(exports.isInstanceGroupInfo, (0, validation_1.isObjectOf)({ type: (0, validation_1.isLiteral)('SANDBOX') }));
exports.isTeamInfo = (0, validation_1.isAllOf)(exports.isInstanceGroupInfo, (0, validation_1.isObjectOf)({
    name: validation_1.isString,
    type: (0, validation_1.isLiteral)('TEAM'),
}));
//# sourceMappingURL=teams.js.map